/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { SaleNoteJoinDocumentService } from '../../sale-notes-join.service';
@Component({
  selector: 'pg-grouped-sales-note',
  templateUrl: './grouped-sales-note.component.html'
})
export class GroupedSalesNoteComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  select = {
    pointOfSale: {
      openDialog: false,
      type: 'single',
      id: null,
      selected: false
    }
  };
  constructor(
    private fb: FormBuilder,
    private serviceBaseJoin: SaleNoteJoinDocumentService
  ) {
    super('', serviceBaseJoin);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      pointOfSale: ['Seleccionar', Validators.required]
    });
  }

  async onSubmit() {
    if (this.checkReadyToOpen()) {
      await this.createItem$(this.parseData(this.fg.value));
      // if (this.message.status === 201) {
      //   this.tokenService.setCanSale(true);
      // }
    }
  }

  parseData(form) {
    return {
      ...form,
      pointSaleId: this.select.pointOfSale.id
    };
  }

  onSelectedPointOfSale(pointOfSale) {
    if (pointOfSale) {
      this.fg
        .get('pointOfSale')
        .setValue(pointOfSale.branchStoreName + ' - ' + pointOfSale.code);
      this.select.pointOfSale.id = pointOfSale.id;
      this.select.pointOfSale.selected = true;
    }
    this.select.pointOfSale.openDialog = false;
  }

  checkReadyToOpen() {
    return this.select.pointOfSale.selected && this.fg.value;
  }
}
